import { useParams } from "react-router-dom";
import { appPaths } from "../Routes";
import { AnalysisChartType } from "../models/app/admin/analysisChart";

export const driverCategoryOptionsEn = {
    drivers: "drivers",
    professionalDrivers: "professionalDrivers",
    greyfleet: "greyfleet",
} as const;

export type DriverCategoryOptionsType =
    (typeof driverCategoryOptionsEn)[keyof typeof driverCategoryOptionsEn];

export type DriverCategory = DriverCategoryOptionsType | string;
type PageParams = {
    chartType?: AnalysisChartType;
};

export const driverPageLocation = (
    location: string
): DriverCategory | string | undefined => {
    const { chartType } = useParams<PageParams>();
    if (location.includes(appPaths.adminProfessionalDrivers)) {
        if (chartType) return `professionalDrivers/${chartType}`;
        return "professionalDrivers";
    }
    if (location === appPaths.adminDrivers || location.includes("drivers")) {
        if (chartType) return `drivers/${chartType}`;
        return "drivers";
    }
    if (location.includes(appPaths.adminGreyFleet)) {
        if (chartType) return `greyfleet/${chartType}`;
        return "greyfleet";
    }
    console.error(
        "The passed location string does not match any driver page location",
        location
    );   
    return;
};
